var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayoutTemplateImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_47991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00018 2.66667V9.33333H5.33352V2.66667C5.33352 1.93017 5.93035 1.33333 6.66685 1.33333H33.3335C34.07 1.33333 34.6668 1.93017 34.6668 2.66667H36.0002C36.0002 1.194 34.8062 0 33.3335 0H6.66685C5.19418 0 4.00018 1.194 4.00018 2.66667Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66685 40H33.3335C34.8062 40 36.0002 38.806 36.0002 37.3334V34.6667H34.6668V37.3334C34.6668 38.0699 34.07 38.6667 33.3335 38.6667C32.597 38.6667 32.0002 38.0699 32.0002 37.3334V35.3334C32.0002 34.965 31.7018 34.6667 31.3335 34.6667H5.33352V21.3334H4.00018V34.6667H0.66685C0.298516 34.6667 0.000183105 34.965 0.000183105 35.3334V37.3334C0.000183105 38.806 1.19418 40 2.66685 40ZM1.33352 36H30.6668V37.3334C30.6665 37.8019 30.7895 38.2617 31.025 38.6667H2.66685C1.93035 38.6667 1.33352 38.0699 1.33352 37.3334V36Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.66685 20H14.0002C14.3685 20 14.6668 19.7016 14.6668 19.3333V11.3333C14.6668 10.965 14.3685 10.6666 14.0002 10.6666H0.66685C0.298516 10.6666 0.000183105 10.965 0.000183105 11.3333V19.3333C0.000183105 19.7016 0.298516 20 0.66685 20ZM1.33352 12H13.3335V18.6666H1.33352V12Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19551 13.5287L2.86218 14.862C2.60201 15.1225 2.60201 15.5442 2.86218 15.8047L4.19551 17.138L5.13818 16.1954L4.27618 15.3334L5.13818 14.4714L4.19551 13.5287Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4715 13.5287L9.52884 14.4714L10.3908 15.3334L9.52884 16.1954L10.4715 17.138L11.8048 15.8047C12.065 15.5442 12.065 15.1225 11.8048 14.862L10.4715 13.5287Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03384 17.1224L7.36784 13.1219L8.63318 13.5439L7.29851 17.5441L6.03384 17.1224Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 4H16.6668C16.2985 4 16.0002 4.29833 16.0002 4.66667V18C16.0002 18.3683 16.2985 18.6667 16.6668 18.6667H39.3335C39.7018 18.6667 40.0002 18.3683 40.0002 18V4.66667C40.0002 4.29833 39.7018 4 39.3335 4ZM38.6668 17.3333H17.3335V15.7107L23.3202 12.1187L29.1567 15.8933C29.3572 16.0225 29.6117 16.035 29.8233 15.9253L34.6498 13.4253L38.6668 15.72V17.3333ZM38.6668 14.1847L35.0002 12.088C34.8038 11.9753 34.5637 11.9708 34.3627 12.0747L29.5582 14.5635L23.6982 10.7733C23.4845 10.6353 23.2108 10.6308 22.9927 10.762L17.3335 14.156V5.33333H38.6668V14.1847Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6669 11.3333C32.9555 11.3333 34.0002 10.2886 34.0002 8.99996C34.0002 7.71129 32.9555 6.66663 31.6669 6.66663C30.3782 6.66663 29.3335 7.71129 29.3335 8.99996C29.3335 10.2886 30.3782 11.3333 31.6669 11.3333ZM31.6669 7.99996C32.2192 7.99996 32.6669 8.44763 32.6669 8.99996C32.6669 9.55229 32.2192 9.99996 31.6669 9.99996C31.1145 9.99996 30.6669 9.55229 30.6669 8.99996C30.6669 8.44763 31.1145 7.99996 31.6669 7.99996Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66684 22V30C6.66684 30.3684 6.96517 30.6667 7.33351 30.6667H24.0002C24.3685 30.6667 24.6668 30.3684 24.6668 30V22C24.6668 21.6317 24.3685 21.3334 24.0002 21.3334H7.33351C6.96517 21.3334 6.66684 21.6317 6.66684 22ZM8.00017 22.6667H23.3335V29.3334H8.00017V22.6667Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33353 24H12.0002V25.3333H9.33353V24Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 24H19.3335V25.3333H13.3335V24Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 24H22.0002V25.3333H20.6668V24Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33353 26.6666H17.3335V28H9.33353V26.6666Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 26.6666H22.0002V28H18.6668V26.6666Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66684 2.66663H8.00017V3.99996H6.66684V2.66663Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33353 2.66663H10.6669V3.99996H9.33353V2.66663Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 2.66663H13.3335V3.99996H12.0002V2.66663Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66684 5.33337H14.6668V6.66671H6.66684V5.33337Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 24H26.6668C26.2985 24 26.0002 24.2983 26.0002 24.6667V32.6667C26.0002 33.035 26.2985 33.3333 26.6668 33.3333H39.3335C39.7018 33.3333 40.0002 33.035 40.0002 32.6667V24.6667C40.0002 24.2983 39.7018 24 39.3335 24ZM38.6668 32H27.3335V25.3333H38.6668V32Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6668 26.6666H30.0002V28H28.6668V26.6666Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6668 29.3334H30.0002V30.6667H28.6668V29.3334Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3335 26.6666H37.3335V28H31.3335V26.6666Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3335 29.3334H37.3335V30.6667H31.3335V29.3334Z",
    fill: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6669 20H36.0002V22.6667H34.6669V20Z",
    fill: "#C7C7C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_47991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutTemplateImage);
export default __webpack_public_path__ + "static/media/layoutTemplateImage.55930bf189ef34c0d4182b73c2efcda9.svg";
export { ForwardRef as ReactComponent };